import { graphql } from 'gatsby';

import { SEO } from 'components';
import { Container, Section } from 'components/GridV2';
import { Benefits, Hero, Why } from 'components/pages/enterprise';
import { Layout } from 'components/rebrand/Layout';
import { SignUp } from 'components/rebrand/SignUp';

import { IEnterprisePageProps } from 'typescriptDefs/pages/enterprise';

const EnterprisePage = ({
  data: { page },
  pageContext: { linkCanonical, locale, pageIsMultilingual, pageName, schemaMarkupJson, variant },
  ...props
}: IEnterprisePageProps) => {
  const heroData = {
    heading: page.heroHeading,
    image: page.heroImg,
    imageAltText: page.heroImgAltText,
    subheading: page.heroSubheading,
  };

  const benefitsData = {
    firstBenefit: page.benefits_01[0],
    secondBenefit: page.benefits_01[1],
  };

  const whyData = {
    heading: page.benefits_02Heading,
    benefits: page.benefits_02,
  };

  return (
    <Layout location={props.location} pageIsMultilingual={pageIsMultilingual} pageName={pageName} pageVariant={variant}>
      <SEO
        canonical={linkCanonical}
        description={page.metadata.description}
        imageSrc={page.metadata.image?.asset?.gatsbyImageData?.images?.fallback?.src}
        keywords={page.metadata.keywords}
        location={props.location}
        multilingual={pageIsMultilingual}
        structuredData={schemaMarkupJson}
        title={page.metadata.title}
      />

      <Hero data={heroData} />
      <Benefits data={benefitsData} />
      <Why data={whyData} />

      <Section className="px-32 pb-64 md:px-[unset] md:pb-96">
        <Container>
          <SignUp
            inverse
            content={page.signUp.content}
            ctaText={page.signUp.ctaText}
            btnProps={{
              buttonVariant: 'primaryInverse',
              buttonLocation: 'Enterprise Sign Up',
              queryParams: { hash: {}, search: {} },
              trackEventProps: {
                category: pageName,
                label: 'Enterprise Sign Up',
                locale,
                location: variant,
              },
            }}
          />
        </Container>
      </Section>
    </Layout>
  );
};

export default EnterprisePage;

export const queryGraphQL = graphql`
  query ($_id: String!) {
    page: sanityPageEnterprise(_id: { eq: $_id }) {
      metadata {
        ...sanityMetadata
      }
      heroHeading: _rawV2HeroHeading
      heroSubheading
      heroImgAltText
      heroImg {
        asset {
          gatsbyImageData(placeholder: NONE, width: 1096)
        }
      }
      benefits_01 {
        heading
        imgMain {
          asset {
            gatsbyImageData(placeholder: NONE, width: 894)
          }
        }
        imgMainAltText
        benefitContent {
          heading
          image {
            altText
            img {
              asset {
                gatsbyImageData(placeholder: NONE, width: 64)
              }
            }
          }
          content: _rawContent
        }
      }
      benefits_02 {
        bodyList
        heading
        imgMain {
          asset {
            gatsbyImageData(placeholder: NONE, width: 894)
          }
        }
        imgMainAltText
        benefitContent {
          heading
          image {
            altText
            img {
              asset {
                gatsbyImageData(placeholder: NONE, width: 64)
              }
            }
          }
          content: _rawContent
        }
      }
      benefits_02Heading
      signUp {
        ...sanitySignUp
      }
    }
  }
`;
